<div class="d-flex">
  <div class="me-3">
    <h1 class="page-title mb-0">Calculate & Record a Pay</h1>
  </div>
  <div class="flex-fill d-inline-flex justify-content-end">
    <div class="title-bar-btn" *ngIf="showCancel">
      <button
        cpGTagEvent
        [params]="{ event_label: 'payroll_manual_checks_cancel' }"
        class="btn btn-secondary"
        (click)="onCancelButton?.emit()">
        Return to Payroll Hub
      </button>
    </div>
    <div class="title-bar-btn" *ngIf="showConfirm">
      <button
        cpGTagEvent
        [params]="{ event_label: 'payroll_manual_checks_preview' }"
        class="btn btn-primary"
        (click)="onConfirmButton?.emit()">
        Payline Details
      </button>
    </div>
  </div>
</div>
<div class="d-flex flex-fill" *ngIf="earliestPayDate">
  <div>
    <small>
      <span class="me-3" data-testid="header-periodBegin">
        First Day of Pay Cycle:&nbsp;<strong>{{
          earliestPayDate.PeriodBegin.toString() | slice: 0 : 10 | date: 'MM/dd/yyyy'
        }}</strong>
      </span>
      <span class="me-3" data-testid="header-periodEnd">
        Last Day of Pay Cycle:&nbsp;
        <strong>
          {{ earliestPayDate.PeriodEnd.toString() | slice: 0 : 10 | date: 'MM/dd/yyyy' }}
        </strong>
      </span>
      <span class="me-3" data-testid="header-payDate">
        Pay Date:&nbsp;<strong>{{
          earliestPayDate.TargetPayDate.toString() | slice: 0 : 10 | date: 'MM/dd/yyyy'
        }}</strong>
      </span>
      <span class="me-3 text-xs">
        *For reference only. Saved pays will be recorded with these dates in the next payroll run.
      </span>
    </small>
  </div>
</div>
